export function usageReducer(state = "" ,{
    type,
    payload
}){
    
    switch(type){
        case "NEW_USAGE":            
        case "UPDATE_USAGE":
            let list = Object.assign({}, state);
            list[payload.usage_id] = payload
        
            return list
            
        case "GET_USAGES":

            return payload
            
        default:
            return state;
    }
    
}